/**
 * Hey Black Moda · carrito
 *
 * <hb-countdown data-end="SEGUNDOS_UNIX_UTC"> cuenta atrás de la oferta.
 * Dentro lleva los números en elementos con data-unit="d|h|m|s" y el bloque de
 * días en data-unit-wrap="d" (se oculta cuando quedan 0 días).
 * Al llegar a cero se oculta solo, para no anunciar una oferta que ya terminó.
 */
class HbCountdown extends HTMLElement {
  /** @type {number} */
  #timer = 0;

  /** @type {number} */
  #end = 0;

  connectedCallback() {
    this.#end = Number(this.dataset.end) * 1000;
    if (!Number.isFinite(this.#end) || this.#end <= 0) return;

    this.#tick();
    window.clearInterval(this.#timer);
    this.#timer = window.setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.#timer);
  }

  #tick() {
    const left = Math.max(0, Math.floor((this.#end - Date.now()) / 1000));
    const days = Math.floor(left / 86400);

    this.#set('d', String(days).padStart(2, '0'));
    this.#set('h', String(Math.floor((left % 86400) / 3600)).padStart(2, '0'));
    this.#set('m', String(Math.floor((left % 3600) / 60)).padStart(2, '0'));
    this.#set('s', String(left % 60).padStart(2, '0'));

    const daysWrap = this.querySelector('[data-unit-wrap="d"]');
    if (daysWrap instanceof HTMLElement) daysWrap.hidden = days === 0;

    if (left === 0) {
      window.clearInterval(this.#timer);
      this.hidden = true;
    }
  }

  /**
   * @param {string} unit
   * @param {string} value
   */
  #set(unit, value) {
    const element = this.querySelector(`[data-unit="${unit}"]`);
    if (element && element.textContent !== value) element.textContent = value;
  }
}

if (!customElements.get('hb-countdown')) {
  customElements.define('hb-countdown', HbCountdown);
}
